function webpackEmptyAsyncContext(req) {
	return new Promise(function(resolve, reject) { reject(new Error("Cannot find module '" + req + "'.")); });
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "ixMg";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src lazy
// module id = ixMg
// module chunks = 1